import { ResizedImage } from '@ah/design/mobile';
import type { ChosenSuperconnector } from '@ah/people/shared';
import { MAIA_PNG } from '../../assets';

export function CardHeader({
  godmother,
  label,
  title,
  subtitle,
}: {
  godmother: ChosenSuperconnector | null;
  label?: string | null;
  title: string;
  subtitle?: string | null;
}) {
  const pictureUrl = godmother?.pictureUrl ?? MAIA_PNG;
  const alt = godmother?.firstName ?? 'Your Underling';
  return (
    <div className="flex items-start gap-3">
      <ResizedImage
        src={pictureUrl}
        renderWidth={44}
        fallback={false}
        alt={alt}
        className="w-11 h-11 rounded-full object-cover ring-2 ring-primary/15 shrink-0"
      />
      <div className="flex-1 min-w-0 space-y-1.5">
        <p className="text-lg font-semibold leading-snug text-foreground">
          {title}
        </p>
        {label && (
          <span className="inline-block text-[10px] uppercase tracking-wider font-semibold text-primary/80 bg-primary/10 rounded-full px-2 py-0.5">
            {label}
          </span>
        )}
        {subtitle && (
          <p className="text-[14px] text-muted-foreground leading-snug">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
